import React, { createContext, useMemo } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
	const { loading, whatsApps } = useWhatsApps();
	// Memoize so the 2 consumers only re-render when whatsApps/loading
	// actually change, not on every provider render (this wraps the whole
	// authenticated app).
	const value = useMemo(() => ({ whatsApps, loading }), [whatsApps, loading]);

	return (
		<WhatsAppsContext.Provider value={value}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
